import { render, staticRenderFns } from "./DataSingleCall.vue?vue&type=template&id=74c5e328&"
import script from "./DataSingleCall.vue?vue&type=script&lang=js&"
export * from "./DataSingleCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports